import {Toast} from 'vant';

export const validateFields = (fieldsList, formState) => {
  const emptyField = fieldsList.find(
    (item) => item.required && !formState[item.field],
  );
  if (emptyField) {
    Toast(`${emptyField.label}不能为空`);
    return false;
  }

  // 日期类型必填字段额外校验合法性，避免 Invalid Date 写入后端
  const invalidDateField = fieldsList.find((item) => {
    if (!item.required || item.type !== 'date') return false;
    const value = formState[item.field];
    if (value === undefined || value === null || value === '') return false;
    const date = new Date(value);
    return Number.isNaN(date.getTime());
  });
  if (invalidDateField) {
    Toast(`${invalidDateField.label}格式不正确`);
    return false;
  }

  return true;
};
